import { useEffect, useState } from "react";
import { jsx } from "@storybook/theming";
import { useParameter, useStorybookState } from "@storybook/api";
import { ParameterName } from "../../addon";
import { Wrapper as Pure } from "../components/Wrapper";
export var Wrapper = function (_a) {
    var active = _a.active;
    var state = useStorybookState();
    var config = useParameter(ParameterName);
    var _b = useState(active), onceRevealed = _b[0], setOnceRevealed = _b[1];
    useEffect(function () {
        setOnceRevealed(active);
    }, [config]);
    useEffect(function () {
        if (active) {
            setOnceRevealed(true);
        }
    }, [active]);
    if (!onceRevealed) {
        return null;
    }
    return jsx(Pure, { key: state.storyId, config: config });
};
export default Wrapper;
